import { TrashItem } from "../gameobjects/TrashItem";

export default class TrashGameModel {
    public static collectedItems: TrashItem[];
    public static round = 1;
    public static roundStartTime = 0;
    public static itemsUsed = new Array<string>();
}
